export const APP_CONFIG = {
  baseDomain: process.env.VUE_APP_ENDPOINT,
  mediaDomain: 'https://media.mamdtech.com',
  authSetting: {
    tokenName: 'token',
  },
  settings: {
    main_domain: 'https://mamdtech.com',
    firebase_prefix: 'oeeorder',
    firebase_storage: 'https://firebasestorage.googleapis.com/v0/b/oee-app-cc5a1.appspot.com/o'
  },
  eventBusAction: {
    disableMenuLeft: 'disableMenuLeft',
    disableHeader: 'disableHeader',
    showHideMenuLeft: 'showHideMenuLeft',
    reloadWithdrawalHistories: 'reloadWithdrawalHistories',
    reloadNotification: 'reloadNotification'
  },
  stateKey: {
    authStore: 'authStore',
    commonStore: 'commonStore',
    cartState: 'cartState',
  },
  sqlDateFormat: 'YYYY-MM-DD hh:mm:ss',
  notifyRefreshTime: 30
};
